import { mapState, mapGetters } from 'vuex'
let editorMixin = {
    data() {
        return {
            isLoading: false,
            requiredRule: v => {
                if (typeof v === 'string' || v instanceof String) {
                    v = v.trim()
                }
                return !!v || 'Required'
            },
        }
    },
    computed: {
        ...mapState(['user']),
        ...mapGetters(['events', 'nextEvent', 'userTeams']),
    },
}

export default editorMixin
